module.exports = __webpack_public_path__ + "img/_search.9c069154.svg";